import(/* webpackMode: "eager" */ "/codebuild/output/src3741541441/src/next-app/app/global-error.tsx");
